var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{key:Date.now(),staticClass:"v-image",style:({borderRadius: _vm.borderRadius}),attrs:{"width":_vm.width,"height":_vm.height},on:{"error":function($event){return _vm.error()},"click":_vm.preview}})}
var staticRenderFns = []

export { render, staticRenderFns }